// Brave deliberately ships no User-Agent token (it presents as Chrome to
// avoid fingerprinting), so the server can't tell Brave apart from Chrome by
// parsing headers alone. We detect it client-side and send the result as a
// header so the admin device list can label it correctly.
interface BraveNavigator extends Navigator {
  brave?: { isBrave: () => Promise<boolean> };
}

let cachedHint: string | null = null;

export const detectBrowserHint = async (): Promise<void> => {
  try {
    const isBrave = await (navigator as BraveNavigator).brave?.isBrave?.();
    cachedHint = isBrave ? 'brave' : null;
  } catch {
    cachedHint = null;
  }
};

export const getBrowserHint = (): string | null => cachedHint;
